import React from "react";


import { Helmet } from 'react-helmet';

import { ThemeProvider as MuiThemeProvider, StylesProvider } from "@material-ui/core/styles";
import { ThemeProvider } from "styled-components";


import maTheme from "./theme";
import RouterConfig from "./router";


const App = () => {
    return (
        <React.Fragment>
            <Helmet
                titleTemplate="%s"
                defaultTitle="Личный кабинет restify.one"
            />
            <StylesProvider injectFirst>
                <MuiThemeProvider theme={maTheme}>
                    <ThemeProvider theme={maTheme}>
                        <RouterConfig />
                    </ThemeProvider>
                </MuiThemeProvider>
            </StylesProvider>
        </React.Fragment>
    );
}

export default App;
